import api from "../../../../../services/api";

export const editItemPrice = (payload) => api.post("routesIfood/editItemPrice", payload);

export const setItemStatus = (payload) => api.post("routesIfood/setItemStatus", payload);

export const setComplementCategoryStatus = (payload) =>
    api.post("routesIfood/setComplementCategoryStatus", payload);

export const setComplementStatus = (payload) => api.post("routesIfood/setComplementStatus", payload);

export const editComplementPrice = (payload) => api.post("routesIfood/editComplementPrice", payload);

export const deleteCategory = (payload) => api.post("routesIfood/deleteCategory", payload);

export const desactiveItem = (payload) => api.post("routesIfood/desactiveItem", payload);

export const deleteComplementCategory = (payload) => api.post("routesIfood/deleteComplementCategory", payload);

export const deleteComplement = (payload) => api.post("routesIfood/deleteComplement", payload);
